import * as React from 'react';
import { AdminItemCardButtons } from 'components';
import { IItemCardProps, IAdminItemCardButtonsProps } from 'models/itemcard';
import * as moment from 'moment';
import { PollStatus } from 'models/enums/statuses';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IPoll } from 'models/polls/poll';
import { IPollOption } from 'models/polls/polloptions';
import { formatInteger, formatPercentage } from 'helpers/common';
require('./style.css');

interface IProps extends IItemCardProps {
	item: IPoll;
	archiveItem?: (itemId: string) => void;
	t?: (key: string, options?: any) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminPollItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.editItem = this.editItem.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.archiveItem = this.archiveItem.bind(this);
	}

	public editItem() {
		if (this.props.editItem) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.editItem(entityIdObj.id);
		}
	}

	public deleteItem(e: any) {
		e.stopPropagation();
		if (this.props.deleteItem) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.deleteItem(entityIdObj.type, entityIdObj.id);
		}
	}

	public archiveItem(e: any) {
		e.stopPropagation();
		if (this.props.archiveItem) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.archiveItem(entityIdObj.id);
		}
	}

	public render() {
		const { currentUserId, currentUserIsAdministrator } = this.props;
		const { status, userId, addedDate, questionText, votes, pollOptions } = this.props.item;
		const { t } = this.props;

		const adminItemCardButtonsProps: IAdminItemCardButtonsProps = {
			deleteItem:
				this.props.deleteItem !== undefined &&
				((status !== PollStatus.Approved && currentUserId === userId) || currentUserIsAdministrator)
					? this.deleteItem
					: null,
			archiveItem:
				this.props.archiveItem !== undefined &&
				status === PollStatus.Approved &&
				(currentUserId === userId || currentUserIsAdministrator)
					? this.archiveItem
					: null,
		};

		const pollOptionsArray = pollOptions
			.sort((a, b) => b.sortOrder - a.sortOrder)
			.map((pollOption: IPollOption) => {
				let optionContent: JSX.Element = null;
				switch (pollOption.sortOrder) {
					case 0:
						optionContent = (
							<div className="divWrapperPoll" key="polloptionitem1key">
								<img src={require('containers/Html/icons/polls/sad.png')} />
								<span className="spanPercentLeft">{formatPercentage(pollOption.percentage)}</span>
								<div className="pollActive" title={formatPercentage(pollOption.percentage)}>
									<div className="pollActivePercentage" style={{ width: `${pollOption.percentage}%` }} />
								</div>
								<span className="spanPercentRight">{formatInteger(pollOption.votes)}</span>
							</div>
						);
						break;

					case 1:
						optionContent = (
							<div className="divWrapperPoll" key="polloptionitem2key">
								<img src={require('containers/Html/icons/polls/no-care.png')} />
								<span className="spanPercentLeft">{formatPercentage(pollOption.percentage)}</span>
								<div className="pollActive" title={formatPercentage(pollOption.percentage)}>
									<div className="pollActivePercentage" style={{ width: `${pollOption.percentage}%` }} />
								</div>
								<span className="spanPercentRight">{formatInteger(pollOption.votes)}</span>
							</div>
						);
						break;

					case 2:
						optionContent = (
							<div className="divWrapperPoll" key="polloptionitem3key">
								<img src={require('containers/Html/icons/polls/happy2.png')} />
								<span className="spanPercentLeft">{formatPercentage(pollOption.percentage)}</span>
								<div className="pollActive" title={formatPercentage(pollOption.percentage)}>
									<div className="pollActivePercentage" style={{ width: `${pollOption.percentage}%` }} />
								</div>
								<span className="spanPercentRight">{formatInteger(pollOption.votes)}</span>
							</div>
						);
						break;

					case 3:
						optionContent = (
							<div className="divWrapperPoll" key="polloptionitem4key">
								<img src={require('containers/Html/icons/polls/happy.png')} />
								<span className="spanPercentLeft">{formatPercentage(pollOption.percentage)}</span>
								<div className="pollActive" title={formatPercentage(pollOption.percentage)}>
									<div className="pollActivePercentage" style={{ width: `${pollOption.percentage}%` }} />
								</div>
								<span className="spanPercentRight">{formatInteger(pollOption.votes)}</span>
							</div>
						);

						break;

					default:
						break;
				}

				return optionContent;
			});

		let approved = false;
		if (status === PollStatus.Approved) {
			approved = true;
		}

		return (
			<div className="col-12 col-sm-6 col-md-6 col-xl-3 col-xlg-3 col-fhd-2 adminPollItemCard">
				<div className="innerHolder" onClick={this.editItem}>
					<div className="container">
						<div className="col-md-12 header">
							<div className={`status ${approved ? 'published' : ''}`}>{t('CodeList_PollStatus_' + status)}</div>
							<AdminItemCardButtons {...adminItemCardButtonsProps} />
						</div>
						<div className="col-md-12 middle">
							<div className="question">
								<span>{questionText}</span>
							</div>
							<div className="options">
								<div className="optionsTop">
									<span className="leftOptions">{t('AdminPollItemCard_Label_Votes')}</span>{' '}
									<span className="rightOptions">{formatInteger(votes)}</span>
								</div>
								<div className="pollColorActive">{pollOptionsArray}</div>
							</div>
						</div>
						<div className="col-md-12 bottom">
							<div className="dateText">
								{t('AdminPollItemCard_Label_CreatedOn') + ' '}
								<span>{moment(addedDate).format('L')}</span>
							</div>
						</div>
					</div>
					<div className="clear" />
				</div>
			</div>
		);
	}
}

export { AdminPollItemCard };
